<template>
  <component
    :is="computedTag"
    :class="['c-btn', `c-btn--${variant}`, { 'c-btn--is-pill': isPill, 'c-btn--has-icon-prepend': iconPrepend, 'c-btn--has-icon-append': iconAppend || showLoader }, typeof size !== 'undefined' ? `c-btn--size-${size}` : null]"
    :type="type"
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
  >
    <font-awesome-icon v-if="iconPrepend" :icon="iconPrepend" class="c-btn__icon-prepend" />
    <span v-if="title" class="c-btn__text">{{ title }}</span>
    <slot/>
    <font-awesome-icon v-if="iconAppend" :icon="iconAppend" class="c-btn__icon-append"/>
    <base-spinner v-if="showLoader" class="ml-2" is-small :is-inversed="isInversedLoader" />
  </component>
</template>

<script>
export default {
  name: 'BaseButton',

  inheritAttrs: false,

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    iconAppend: {
      type: Array
    },
    iconPrepend: {
      type: Array
    },
    showLoader: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => [ 'primary', 'secondary', 'default', 'danger', 'outline-primary', 'outline-primary-alt', 'outline-secondary', 'link', 'link-primary', 'link-success', 'link-danger', 'link-light' ].includes(value)
    },
    isPill: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: undefined,
      validator: value => ['sm'].includes(value)
    },
    type: {
      type: String,
      default: 'button',
      validator: value => ['button', 'submit', 'reset'].includes(value)
    },
    tag: {
      type: String,
      default: 'button',
      validator: value => ['a', 'button', 'div', 'router-link'].includes(value)
    }
  },

  computed: {
    computedTag () {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return 'button'
      }
      return this.tag
    },

    isInversedLoader () {
      return !['default', 'link', 'outline-primary-alt'].includes(this.variant)
    }
  }
}
</script>
